import { createSelector } from '@reduxjs/toolkit';

import { Bearing, Component } from '@paragon/contract-library';
import { calculateBearingVisualData } from '@paragon/three-shared';

// The selector in this file has arguments of (component: Component, bearing: Bearing) instead of typical selectors
// that take (state: RootState) as an argument.

const getComponent = (component: Component) => component;
const getBearing = (component: Component, bearing: Bearing) => bearing;

export const getBearingVisualData = createSelector(getComponent, getBearing, (component, bearing) =>
  calculateBearingVisualData(bearing, component),
);
